import { render, staticRenderFns } from "./CompanyNews.vue?vue&type=template&id=211a3f5a"
import script from "./CompanyNews.vue?vue&type=script&lang=js"
export * from "./CompanyNews.vue?vue&type=script&lang=js"
import style0 from "./CompanyNews.vue?vue&type=style&index=0&id=211a3f5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports